// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csi-components-overlay-ComponentOverlay-module-componentOverlayWrapper {
	position: relative;
}

.csi-components-overlay-ComponentOverlay-module-internalOverlay {
	height: 100%;
	left: 0;
	pointer-events: all;
	position: absolute;
	top: 0;
	width: 100%;
	z-index: 3;
}

.csi-components-overlay-ComponentOverlay-module-overlay {
	height: 100%;
	left: 0;
	opacity: 0.6;
	pointer-events: all;
	position: absolute;
	top: 0;
	width: 100%;
}

.csi-components-overlay-ComponentOverlay-module-zIndexBelowChildren {
	z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/csi/components/overlay/ComponentOverlay.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,OAAO;CACP,mBAAmB;CACnB,kBAAkB;CAClB,MAAM;CACN,WAAW;CACX,UAAU;AACX;;AAEA;CACC,YAAY;CACZ,OAAO;CACP,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,MAAM;CACN,WAAW;AACZ;;AAEA;CACC,UAAU;AACX","sourcesContent":[".componentOverlayWrapper {\n\tposition: relative;\n}\n\n.internalOverlay {\n\theight: 100%;\n\tleft: 0;\n\tpointer-events: all;\n\tposition: absolute;\n\ttop: 0;\n\twidth: 100%;\n\tz-index: 3;\n}\n\n.overlay {\n\theight: 100%;\n\tleft: 0;\n\topacity: 0.6;\n\tpointer-events: all;\n\tposition: absolute;\n\ttop: 0;\n\twidth: 100%;\n}\n\n.zIndexBelowChildren {\n\tz-index: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"componentOverlayWrapper": `csi-components-overlay-ComponentOverlay-module-componentOverlayWrapper`,
	"internalOverlay": `csi-components-overlay-ComponentOverlay-module-internalOverlay`,
	"overlay": `csi-components-overlay-ComponentOverlay-module-overlay`,
	"zIndexBelowChildren": `csi-components-overlay-ComponentOverlay-module-zIndexBelowChildren`
};
module.exports = ___CSS_LOADER_EXPORT___;
